<template>
  <div>
    <div class="pro-label" v-show="next" @touchend="lock = true">
      <div
        class="box"
        :style="`width:${windowWidth}px;height:${windowHeight}px`"
        v-touch:panmove="swipeMove"
        v-touch:panstart="swipeStart"
      >
        <div
          class="thumb-pistion"
          :style="`width:${canvasWidth}px;height:${canvasHeight}px;transform: translate(${
            canvasLeft * -1
          }px,${canvasTop}px) scale(${scale});transform-origin:${scaleX}px ${scaleY}px;`"
          v-touch:pinchmove="pinchmove"
        >
          <thumb-tagging
            class="thumb-tag"
            :isShow="isShow"
            :isHandle="isHandle"
            ref="tagging"
            :width="canvasWidth"
            :height="canvasHeight"
            :taggingimg="dataInfo.addition.path"
            :pointerList="pointerList"
            :flag="flag"
            @selectItem="selectItem"
            @addPart="addPart"
            @isflog="isflog"
            @touchStart="touchStart"
            @changeLock="changeLock"
          ></thumb-tagging>
        </div>
      </div>

      <div
        class="topnav"
        @click="clickshowTop"
        :class="[
          {
            active: dataInfo.prfTLookDecide.temporary != 2 && showTop,
            show: showTop,
          },
        ]"
        v-if="!isHandle"
      >
        <div>
          <div>样品编号:</div>
          {{ dataInfo.proofListVo.sampleNo }}
        </div>
        <div>
          <div>产品编号:</div>
          {{ dataInfo.product.productNo }}
        </div>
        <div>
          <div>看样人:</div>
          {{ dataInfo.user.username }}
        </div>
        <template v-if="dataInfo.prfTLookDecide.temporary != 2 && showTop">
          <div class="time" v-if="!dataInfo.isTimeoutOne">
            还有<span>{{ dataInfo.oneDay }}</span
            >天超时
          </div>
          <div class="time" v-else>
            已超时<span>{{ dataInfo.oneDay }}</span
            >天
          </div>
        </template>
        <i class="iconfont icon-xiala" :class="{ active: showTop }"></i>
      </div>
      <template v-if="dataInfo.prfTLookDecide.temporary != 2">
        <div class="fontBut" v-if="!isHandle">
          <div class="but" @click="mark">我要标记</div>
          <div class="but" @click="nextWeb">下一步</div>
        </div>
        <div class="fontBut" v-else>
          <div class="but" @click="save">保存标记</div>
        </div>
      </template>
      <div class="fontBut" v-else>
        <div class="but active" @click="nextWeb">查看看样意见</div>
      </div>
      <van-popup
        v-model="showBottom"
        round
        :close-on-click-overlay="false"
        @click-overlay="clickOverlay"
        position="bottom"
      >
        <div class="popup-box">
          <div class="popup-title">
            <div @click="close">删除</div>
            <div @click="saveNote">保存</div>
          </div>
          <div>
            <van-field
              v-model="message"
              :cursor-spacing="0"
              rows="4"
              autosize
              type="textarea"
              placeholder="请输入标点说明,最多输入500个字..."
            >
            </van-field>
            <div class="radio">
              <span class="text">需要业务员确认：</span>
              <div class="list">
                <div
                  @click="businessAffirm = 1"
                  class="item"
                  :class="{ active: businessAffirm === 1 }"
                >
                  <div class="garden">
                    <div class="solid"></div>
                  </div>
                  <div class="value">是</div>
                </div>
                <div
                  @click="businessAffirm = 0"
                  class="item"
                  :class="{ active: businessAffirm === 0 }"
                >
                  <div class="garden">
                    <div class="solid"></div>
                  </div>
                  <div class="value">否</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <next-web
      ref="nextWeb"
      @chooseUser="getDetailInfo"
      @backTo="nextWeb"
      :nextpointerList="nextpointerList"
      :salesmanList="salesmanList"
      :dataInfo="dataInfo"
      v-show="!next"
      :cIsPublish.sync="cIsPublish"
    ></next-web>
  </div>
</template>

<script>
import ThumbTagging from "../components/ThumbTagging.vue";
import nextWeb from "../views/SampleOpinion.vue";
import { sampleApi } from "../api/lookApi/api";

const pageApi = new sampleApi();

export default {
  data() {
    return {
      showTop: false,
      fabricObj: "",
      dataInfo: {
        addition: {},
        orderList: [],
        proofListVo: {},
        prfTLookDecide: {
          temporary: "",
        },
        prfTLookLog: {},
        prfTLookMain: {},
        product: {},
        user: {},
        isProGroup: false,
      },
      pointerList: [],
      showBottom: false,
      isHandle: false,
      isShow: true,
      imageData: "",
      message: "",
      businessAffirm: 1,
      windowWidth: document.documentElement.clientWidth, //获取屏幕宽度
      windowHeight: document.documentElement.clientHeight - 110, //获取屏幕高度
      canvasWidth: ((document.documentElement.clientHeight - 110) / 3) * 4, //获取屏幕宽度
      canvasHeight: document.documentElement.clientHeight - 110, //获取屏幕高度
      canvasLeft:
        (((document.documentElement.clientHeight - 110) / 3) * 4 -
          document.documentElement.clientWidth) /
        2,
      canvasTop: 0,
      next: true,
      nextpointerList: [],
      partIndex: 0,
      scale: 1,
      scalelock: false,
      flag: true,
      moveX: 0,
      moveY: 0,
      scaleX: 0,
      scaleY: 0,
      nowScale: 1,
      salesmanList: [],
      lock: true,
      cIsPublish: false,
    };
  },
  computed: {
    userId() {
      return this.$route.query.userId;
    },
  },
  methods: {
    async getUserList() {
      const info = {
        proofId: this.$route.query.proofId,
        userType: 1,
      };
      const list = await pageApi.getSalesmanList(info);
      /* 如果当前登录用户也在看样意见人里面，则将其移到数组第一个 */
      let user = null;
      let newList = [];
      list.forEach((item, index) => {
        if (item.userId == this.userId) {
          user = {
            value: item.userId,
            text: item.userName,
            isProGroup: item.isProGroup,
          };
        } else {
          newList.push({
            value: item.userId,
            text: item.userName,
            isProGroup: item.isProGroup,
          });
        }
      });
      if (user) {
        newList.unshift(user);
      }
      this.salesmanList = newList.filter((user) => {
        return newList.length != 1 || user.value != this.userId;
      });
      if (this.salesmanList.length > 0) {
        this.cIsPublish = !this.salesmanList[0].isProGroup;
      } else {
        // 无数据
        this.cIsPublish = !this.dataInfo.isProGroup;
      }
    },
    // 展开收起
    clickshowTop() {
      this.showTop = !this.showTop;
    },
    touchStart(e) {
      if (this.lock) {
        this.scaleX = e.pointer.x;
        this.scaleY = e.pointer.y;
      }
    },
    swipeStart(e) {
      if (this.lock) {
        this.moveX = e.X;
        this.moveY = e.Y;
      }
    },
    changeLock() {
      this.lock = false;
    },
    // 拖动
    swipeMove(e) {
      if (this.lock) {
        if (e.X > this.moveX) {
          this.canvasLeft = this.canvasLeft - (e.X - this.moveX);
        } else {
          this.canvasLeft = this.canvasLeft + (this.moveX - e.X);
        }
        if (e.Y > this.moveY) {
          this.canvasTop = this.canvasTop + (e.Y - this.moveY);
        } else {
          this.canvasTop = this.canvasTop - (this.moveY - e.Y);
        }
        this.moveX = e.X;
        this.moveY = e.Y;

        if (this.flag) {
          this.flag = false;
        }
      }
    },
    pinchmove(e) {
      if (e.scale == this.nowScale) {
        return false;
      }
      if (e.scale > this.nowScale) {
        if (this.scale <= 2) {
          this.scale = this.scale + 0.02;
        }
      } else {
        if (this.scale >= 1) {
          this.scale = this.scale - 0.02;
        }
      }
      if (this.flag) {
        this.flag = false;
      }
      this.nowScale = e.scale;
    },

    isflog() {
      this.flag = true;
    },
    // 添加标记
    addPart(e) {
      this.nextpointerList.push({
        partId: "",
        pointId: "",
        pid: e.pid ? e.pid : "",
        userId: this.$route.query.userId,
        content: "",
        x: e.left,
        y: e.top,
        userName: this.dataInfo.user.username,
      });
    },
    // 标记
    mark() {
      this.isHandle = true;
      this.isShow = false;
    },
    // 保存退出
    save() {
      this.isShow = true;
      this.isHandle = false;
      this.pointerList = JSON.parse(JSON.stringify(this.nextpointerList));
    },
    //关闭
    close() {
      this.$refs.tagging.deleteAnno(this.nextpointerList[this.partIndex].pid);
      this.nextpointerList.splice(this.partIndex, 1);

      this.showBottom = false;
    },
    // 选中或者添加一个点
    selectItem(target) {
      if (this.isHandle && target.userId == this.$route.query.userId) {
        this.nextpointerList.forEach((item, index) => {
          if (item.pid == target.pid) {
            this.partIndex = index;
            this.message = JSON.parse(
              JSON.stringify(this.nextpointerList[index].content)
            );
          }
        });
        this.showBottom = true;
      }
    },
    // 上下
    nextWeb() {
      this.next = !this.next;
      if (this.next) {
        this.$store.commit("changeTitle", "");
      } else {
        this.$store.commit("changeTitle", "填写看样意见");
      }
    },
    // 点击遮罩
    clickOverlay() {
      if (!this.nextpointerList[this.partIndex].content) {
        this.$refs.tagging.deleteAnno(this.nextpointerList[this.partIndex].pid);
        this.nextpointerList.splice(this.partIndex, 1);
      }
      this.showBottom = false;
      this.$refs["tagging"].noPointer();
    },
    saveNote() {
      if (this.message) {
        this.nextpointerList[this.partIndex].content = this.message;
        this.nextpointerList[this.partIndex].businessAffirm =
          this.businessAffirm;
        this.showBottom = false;
        this.$refs["tagging"].noPointer();
      } else {
        this.$notify({
          message: "请输入意见",
          type: "danger",
          duration: 5000,
        });
      }
    },
    async handleInit() {
      document.title = "索贝森林";
      window.localStorage.setItem("userId", this.$route.query.userId);
      await this.getUserList();
      let userIds = this.salesmanList.map((per) => {
        return per.value;
      });
      let userId =
        userIds.indexOf(this.userId) != -1 || !userIds[0]
          ? this.userId
          : userIds[0];
      this.$refs.nextWeb.userInfo = this.salesmanList[0];
      await this.getDetailInfo(userId);
      let info2 = {
        proofId: this.$route.query.proofId,
        userId: "",
      };

      let pointer = await pageApi.getPointListByUserId(info2);
      pointer.forEach((item) => {
        item.pid = item.pointId;
      });
      this.nextpointerList = JSON.parse(JSON.stringify(pointer));
      this.pointerList = pointer;
      if (this.salesmanList.length > 0) {
        this.cIsPublish = !this.salesmanList[0].isProGroup;
      } else {
        // 无数据
        this.cIsPublish = !this.dataInfo.isProGroup;
      }
    },
    async getDetailInfo(userId) {
      let info = {
        proofId: this.$route.query.proofId,
        userId: userId,
      };
      let res = await pageApi.getDecideInfoMobile(info);
      if (!res.prfTLookDecide) {
        res.prfTLookDecide = {
          temporary: "",
        };
      }
      res.prfTLookMain = res.prfTLookMain
        ? res.prfTLookMain
        : { countryList: [] };
      this.dataInfo = res;
    },
  },
  components: { ThumbTagging, nextWeb },
  async mounted() {
    this.handleInit();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const stashInfo = vm.$store.state.stashInfo;
      if (from.name != "chooseStash") {
        vm.handleInit();
      } else if (from.name == "chooseStash" && stashInfo.isDel) {
        vm.$refs.nextWeb.$refs.form.stashDel();
      } else if (from.name == "chooseStash" && stashInfo.codeId) {
        vm.$refs.nextWeb.$refs.form.handleStash(stashInfo);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.thumb-pistion {
  position: absolute;
  transform-origin: center;
}

.popup-box {
  padding: 20px 30px 30px;

  .popup-title {
    display: flex;
    justify-content: space-between;
    font-size: 24px;

    > div {
      color: #3f996c;

      &:first-child {
        color: #909399;
      }
    }
  }

  .van-field {
    border: 1px solid #dbdbdb;
    margin-top: 30px;
  }

  .radio {
    margin-top: 39px;
    display: flex;
    align-items: center;

    .text {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 32px;
      color: #303133;
    }

    .list {
      display: flex;
      gap: 89px;

      .item {
        display: flex;
        align-items: center;
        gap: 16px;

        &.active {
          .value {
            color: #3f996c;
          }

          .garden {
            border-color: #3f996c;
            .solid {
              background-color: #3f996c;
            }
          }
        }

        .garden {
          width: 40px;
          height: 40px;
          background: #ffffff;
          border-radius: 50%;
          border: 1px solid #dbdbdb;
          display: flex;
          align-items: center;
          justify-content: center;

          .solid {
            width: 20px;
            height: 20px;
            background: #fff;
            border-radius: 50%;
          }
        }

        .value {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 32px;
          color: #303133;
        }
      }
    }
  }
}

.pro-label {
  width: 100%;
  position: relative;
  height: calc(100vh - 88px);
  overflow: hidden;
  background: #f1f1f1;

  .box {
    position: relative;
  }

  .thumb-tag {
    position: absolute;
  }

  canvas {
    width: 100%;
    height: 100%;
  }

  .topnav {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 10px 20px 10px;
    text-align: left;
    word-break: break-all;
    word-wrap: break-word;
    height: 68px;
    overflow: hidden;
    transition: all 0.3s;

    &.show {
      height: auto;
      max-height: 280px;
    }

    > div {
      color: #303133;
      font-size: 32px;
      line-height: 52px;
      display: flex;

      > div {
        width: 150px;
        flex-shrink: 0;
        text-align: right;
        margin-right: 10px;
        word-break: break-all;
        word-wrap: break-word;
      }

      &.active {
        text-align: right;
        line-height: 52px;
      }
    }

    &.active {
      padding-bottom: 66px;
    }

    .time {
      position: absolute;
      right: 20px;
      bottom: 20px;
      color: #909399;
      font-size: 26px;
      text-align: right;

      span {
        color: #3f996c;
      }
    }

    i {
      position: absolute;
      right: 20px;
      top: 24px;

      &.active {
        transform-origin: center;
        transform: rotate(180deg);
      }
    }
  }
}
</style>
